export interface ISettings {
    baseUrl: string;
    authUrl: string;
    serviceUrl: string;
}

export const settings = (): ISettings => {

    // const baseUrl: string = 'https://globalbilge.com/api/';
    // const authUrl: string = 'https://globalbilge.com/connect/token';
    // // const serviceUrl: string = 'https://api.igc.network/api/'
    // const serviceUrl: string = 'https://api.globalbilge.com/api/'

    const baseUrl: any = process.env.REACT_APP_BASE_URL;
    const authUrl: any = process.env.REACT_APP_AUTH_URL;
    const serviceUrl: any = process.env.REACT_APP_SERVICE_URL;


    return {
        baseUrl,
        authUrl,
        serviceUrl
    }

}

export async function createHeaders(isFormData?: boolean): Promise<any> {
    let headers = {} as any;
    //headers['X-IgcMobile-DeviceId'] = settings.deviceId;
    headers['Content-Type'] = isFormData ? 'multipart/form-data' : 'application/json; charset=utf-8';
    let token = localStorage.getItem('token');
    if (token != null) {
        headers['Authorization'] = 'Bearer ' + token;
    }
    return headers;
}

export const getCoords = async (): Promise<any> => {
    try {
        const pos: any = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        return {
            long: pos?.coords?.longitude,
            lat: pos?.coords?.latitude,
        };
    } catch (error) {
        console.error('Geolocation is not supported, err=>', error);
        return null;
    }
};

export async function enhanceBlobImageQuality(blob, quality = 0.92): Promise<Blob> {
    const imgBitmap = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = imgBitmap.width;
    canvas.height = imgBitmap.height;
    ctx?.drawImage(imgBitmap, 0, 0);

    imgBitmap.close();

    try {
        return new Promise((resolve) => {
            canvas.toBlob(
                (enhancedBlob) => {
                    if (enhancedBlob) {
                        resolve(enhancedBlob)
                    } else {
                        resolve(blob)
                    }
                },
                'image/png',
                quality
            );
        });

    } finally {
        canvas.width = 1;
        canvas.height = 1;
        ctx?.clearRect(0, 0, 1, 1);
    }
}

export function guidGenerator() {
    const S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}